import { render, staticRenderFns } from "./scoreAnalysis.vue?vue&type=template&id=0dc984a3&scoped=true&"
import script from "./scoreAnalysis.vue?vue&type=script&lang=js&"
export * from "./scoreAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./scoreAnalysis.vue?vue&type=style&index=0&id=0dc984a3&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc984a3",
  null
  
)

export default component.exports